import { EventType } from '@rcp/types';
import { Resource, localizationService } from 'src/services';
import { RestSlice } from '../../../../../../redux/rest.slice';

export const availableEventTypeSlice = new RestSlice<EventType>(
	localizationService.getLocalizedString('eventType.eventTypes'),
	Resource.EventTypes
);
export const availableEventTypeReducer = availableEventTypeSlice.rests.reducer;
